import { GridToolbarContainer, gridColumnPositionsSelector, useGridApiContext } from "@mui/x-data-grid";
import { Box } from '@mui/system';

import BillzTypographyGridHeader from 'components/BillzTypographies/BillzTypographyGridHeader';
import * as Styled from '../DocumentPreview.styles';
import React from "react";

export const TaxGridToolbar = () =>{
    const apiRef = useGridApiContext(); 
    const columnPositionsSelector = gridColumnPositionsSelector(apiRef); 
 
    return (
        <GridToolbarContainer>
            <Box width='100%' height={32}>
                <Box position='relative' left={columnPositionsSelector[1]}>
                    <BillzTypographyGridHeader>W tym:</BillzTypographyGridHeader>
                </Box>         
                <Styled.Divider/>
            </Box>            
        </GridToolbarContainer>
    );
}